import React, { Fragment, useEffect, useRef } from "react";
import { handleGetApiGF, rupeesFn, Toast } from "../Utils/general-function";
import $ from "jquery";
import "datatables.net-bs5";
import Invoice from "./Invoice";
import useTrueFalse from "../hooks/useTrueFalse";
import NoCars from "../Utils/NoCars";

const TransactionList = () => {
  const { isTrue, setIsTrue } = useTrueFalse();
  const [state, setState] = React.useState({
    transactionList: [],
    transactionId: null,
  });

  const fetchTransactionList = async () => {
    const res = await handleGetApiGF({
      url: "/api/WalletTransaction/AllWalletTransaction?time=" + Date.now(),
    });
    if (!res?.succ) {
      Toast(false, "", res?.msg || "Failed to fetch transactions");
      return;
    }

    setState((prev) => ({ ...prev, transactionList: res?.data?.Data || [] }));
  };

  useEffect(() => {
    fetchTransactionList();
  }, []);
  console.log("state.transactionList", state.transactionList);

  return (
    <div>
      <div className="text-center">
        <h2 className="page-title">Transactions</h2>
      </div>
      <div className="txn-container">
        {state.transactionList.length > 0 ? (
          state.transactionList.map((item) => (
            <Fragment key={item.Id}>
              <div className="txn-card">
                {/* LEFT ICON */}
                <div className="txn-icon">
                  {item.nTransactionStatus === "Success" ? (
                    <span className="material-symbols-outlined text-success fw-bold">
                      check
                    </span>
                  ) : (
                    "⏳"
                  )}
                </div>
                {/* MAIN CONTENT */}
                <div className="txn-content">
                  {/* TOP */}
                  <div className="txn-top">
                    <span
                      className={`txn-status ${item.nTransactionStatus.toLowerCase()}`}
                    >
                      {item.nTransactionStatus}
                    </span>

                    <span
                      className={`txn-amount ${item.nTransactionStatus.toLowerCase()}`}
                    >
                      {rupeesFn(item.dcFinalAmount)}
                    </span>
                  </div>

                  {/* ID */}
                  <div className="txn-id">{item.bTransactionId}</div>

                  {/* GST */}
                  <div className="txn-gst">
                    ₹ {item.dcAmount_withoutgst} + ₹ {item.dcTaxAmount} GST (
                    {item.dcGstPercentage}%)
                  </div>

                  {/* FOOTER */}
                  <div className="txn-footer">
                    <div>
                      <span>
                        {new Date(item.dTransactionDate).toLocaleString(
                          "en-IN",
                        )}
                      </span>
                      <div>
                        <span
                          className={`wallet-status ${item.WalletStatus.toLowerCase()}`}
                        >
                          {item.WalletStatus === "NotCredited"
                            ? "Payment Failed"
                            : item.WalletStatus}
                        </span>
                      </div>
                    </div>
                    {item.nTransactionStatus.toLowerCase() === "success" && (
                      <button
                        className="cardoc-btn text-danger d-flex align-items-center fs-6 invoice"
                        onClick={(e) => {
                          setState((pre) => ({
                            ...pre,
                            transactionId: item?.Id,
                          }));
                          setIsTrue(true);
                        }}
                      >
                        Invoice
                        <span class="material-symbols-outlined text-danger ms-1">
                          downloading
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </Fragment>
          ))
        ) : (
          <NoCars img="" mainMsg="No Transaction Found" msg="" />
        )}
      </div>

      <Invoice
        transactionId={state.transactionId}
        isTrue={isTrue}
        setIsTrue={setIsTrue}
      />
    </div>
  );
};

export default TransactionList;

// import React, { useState, useMemo } from "react";
// import {
//   useReactTable,
//   getCoreRowModel,
//   getPaginationRowModel,
//   getSortedRowModel,
//   getFilteredRowModel,
//   flexRender,
// } from "@tanstack/react-table";

// // 📊 Dummy Data
// const generateData = () => {
//   const names = ["Rajjj", "Amit", "Priyaa", "Neha", "Karan", "Vikas"];
//   return Array.from({ length: 50 }, (_, i) => ({
//     id: i + 1,
//     name: names[Math.floor(Math.random() * names.length)],
//     email: `user${i + 1}@mail.com`,
//     age: Math.floor(Math.random() * 40) + 1800,
//   }));
// };

// export default function App() {
//   const data = useMemo(() => generateData(), []);

//   const columns = useMemo(
//     () => [
//       {
//         accessorKey: "id",
//         header: "ID",
//       },
//       {
//         accessorKey: "name",
//         header: "Name",
//       },
//       {
//         accessorKey: "email",
//         header: "Email",
//       },
//       {
//         accessorKey: "age",
//         header: "Age",
//       },
//     ],
//     []
//   );

//   const [globalFilter, setGlobalFilter] = useState("");
//   const [sorting, setSorting] = useState([]);

//   const table = useReactTable({
//     data,
//     columns,
//     state: {
//       globalFilter,
//       sorting,
//     },
//     onGlobalFilterChange: setGlobalFilter,
//     onSortingChange: setSorting,
//     getCoreRowModel: getCoreRowModel(),
//     getPaginationRowModel: getPaginationRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     getFilteredRowModel: getFilteredRowModel(),
//   });

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial" }}>
//       <h2>TanStack Table Demo</h2>

//       {/* 🔍 Search */}
//       <input
//         placeholder="Search..."
//         value={globalFilter ?? ""}
//         onChange={(e) => setGlobalFilter(e.target.value)}
//         style={{ marginBottom: "10px", padding: "8px", width: "200px" }}
//       />

//       {/* 📊 Table */}
//       <div style={{ overflowX: "auto" }}>
//         <table border="1" cellPadding="10" width="100%" style={{border:"1px solid black"}}>
//           <thead>
//             {table.getHeaderGroups().map((headerGroup) => (
//               <tr key={headerGroup.id} style={{border:"1px solid black"}}>
//                 {headerGroup.headers.map((header) => (
//                   <th

//                     key={header.id}
//                     onClick={header.column.getToggleSortingHandler()}
//                     style={{ cursor: "pointer",border:"1px solid black" }}
//                   >
//                     {flexRender(
//                       header.column.columnDef.header,
//                       header.getContext()
//                     )}

//                     {{
//                       asc: " 🔼",
//                       desc: " 🔽",
//                     }[header.column.getIsSorted()] ?? null}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>

//           <tbody>
//             {table.getRowModel().rows.length > 0 ? (
//               table.getRowModel().rows.map((row) => (
//                 <tr key={row.id} style={{border:"1px solid black"}}>
//                   {row.getVisibleCells().map((cell) => (
//                     <td key={cell.id} style={{border:"1px solid black"}}>
//                       {flexRender(
//                         cell.column.columnDef.cell,
//                         cell.getContext()
//                       )}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={columns.length}>No data found</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* 📄 Pagination */}
//       <div style={{ marginTop: "15px" }}>
//         <button
//           onClick={() => table.previousPage()}
//           disabled={!table.getCanPreviousPage()}
//         >
//           Previ
//         </button>

//         <span style={{ margin: "0 10px" }}>
//           Page {table.getState().pagination.pageIndex + 1} of {" "}
//           {table.getPageCount()}
//         </span>

//         <button
//           onClick={() => table.nextPage()}
//           disabled={!table.getCanNextPage()}
//         >
//           Nexti
//         </button>
//       </div>
//     </div>
//   );
// }
